import { NAME } from "../configs/index";
export default {
	about: {
		about: "เกี่ยวกับ",
		about_name: `เกี่ยวกับ ${NAME}`,
		tab: {
			about: "เกี่ยวกับ",
			point: "คะแนนสิทธิพิเศษ",
			invoice: "ใบแจ้งหนี้",
			privilege_config: "ตั้งค่าสิทธิพิเศษ",
			nearby_config: "ตั้งค่าร้านค้าใกล้ๆ"
		}
	},
	invoice: {
		invoice: "ใบแจ้งหนี้"
	},
	invoicelog: {
		invoicelog: "รายการใบแจ้งหนี้"
	},
	project: {
		project: "โครงการ",
		tab: {
			general: "ทั่วไป",
			payment: "การชำระเงิน"
		}
	},
	saleagency: {
		saleagency: "ตัวแทนขาย",
		tab: {
			general: "ทั่วไป",
			invoice: "ใบแจ้งหนี้"
		}
	},
	service: {
		service: "บริการ",
		tab: {
			general: "ทั่วไป",
			invoice: "ใบแจ้งหนี้"
		}
	},
	line: {
		line: "Line"
	},
	areainfo: {
		areainfo: "ข้อมูลพื้นที่",
		tab: {
			name: "ชื่อ",
			description: "รายละเอียด",
			other: "อื่นๆ"
		}
	},
	bill: {
		bill: "บิล"
	},
	interesting: {
		interesting: "ห้องที่น่าสนใจ",
		tab: {
			general: "ทั่วไป",
			brochure: "โบรชัวร์",
			project_info: "ข้อมูลโครงการ",
			promotion: "โปรโมชั่น"
		}
	},
	announce: {
		announce: "ประกาศจากนิติ",
		tab: {
			title: "หัวข้อ",
			description: "รายละเอียด",
			other: "อื่นๆ"
		}
	},
	facilities: {
		facilities: "สิ่งอำนวยความสะดวก",
		tab: {
			general: "ทั่วไป",
			booking: "การจอง"
		}
	},
	facilitybooking: {
		facilitybooking: "จองสิ่งอำนวยความสะดวก"
	},
	group: {
		group: "กลุ่ม"
	},
	hotline: {
		hotline: "สายด่วน"
	},
	message: {
		message: "ข้อความ/ใบเสนอราคา"
	},
	payment: {
		payment: "การชำระเงินรายเดือน"
	},
	paymentinvoice: {
		paymentinvoice: "ใบเสร็จการชำระเงิน",
		tab: {
			inform: "ข้อมูลที่แจ้ง",
			messagestatus: "ข้อความและสถานะ"
		}
	},
	repair: {
		repair: "ซ่อมแซม",
		tab: {
			inform: "ข้อมูลที่แจ้ง",
			messagestatus: "ข้อความและสถานะ",
			rating: "คะแนน"
		}
	},
	room: {
		room: "ห้อง",
		tab: {
			general: "ทั่วไป",
			owner: "ผู้อาศัย",
			images: "รูป",
			owner_menu: "เมนูสำหรับเจ้าของ",
			rent_menu: "เมนูสำหรับผู้เช่า"
		}
	},
	sos: {
		sos: "ฉุกเฉิน"
	},
	user: {
		user: "ผู้ใช้งาน",
		tab: {
			user: "ผู้ใช้งาน",
			role: "สิทธิ์"
		}
	},
	resources: {
		about: {
			fields: {
				scan_point: "คะแนนการสแกน",
				share_point: "คะแนนการแชร์",
				service_point: "คะแนนการใช้บริการ",
				invoice_to: "ใบแจ้งนี้ถึง (ตัวอย่าง John Doe)",
				invoice_company: "ใบแจ้งนี้ถึงบริษัท (ตัวอย่าง Apple)",
				invoice_address: "ที่อยู่ใบแจ้งนี้",
				cost_member: "ค่าสมาชิก คน/เดือน",
				cost_scan: "ค่าสแกน/ครั้ง",
				privilege_url: "URL สิทธิพิเศษ",
				privilege_appid: "APP ID สิทธิพิเศษ",
				privilege_apikey: "API KEY สิทธิพิเศษ",
				nearby_url: "URL ร้านค้าใกล้"
			}
		},
		invoice: {
			fields: {
				no_invoice: "หมายเลขใบแจ้งหนี้",
				type: "ประเภทใบแจ้งหนี้",
				name: "ชื่อของใบแจ้งหนี้",
				date: "รอบบิลใบแจ้งหนี้",
				date_lte: "วันสิ้นสุดของใบแจ้งหนี้",
				date_gte: "วันเริ่มต้นของใบแจ้งหนี้",
				no_invoice_contains: "หมายเลขใบแจ้งหนี้",
				type: "ประเภทใบแจ้งหนี้",
				name_contains: "ชื่อของใบแจ้งหนี้"
			}
		},
		invoicelog: {
			fields: {
				invoice_date_lte: "วันสิ้นสุดของใบแจ้งหนี้",
				invoice_date_gte: "วันเริ่มต้นของใบแจ้งหนี้",
				type: "ประเภทใบแจ้งหนี้",
				name_contains: "ชื่อของใบแจ้งหนี้",
				user_email_contains: "อีเมล์สมาชิก",
				name: "ชื่อของใบแจ้งหนี้",
				user_email: "อีเมล์สมาชิก"
			}
		},
		project: {
			fields: {
				name: "ชื่อโครงการ",
				project_progress: "ความคืบหน้าของโครงการ (Url)",
				payment: {
					account: "บัญชี"
				}
			}
		},
		repairtype: {
			fields: {
				name: "ชื่อ",
				project: "โครงการ",
				order: "ลำดับ",
				name_contains: "ชื่อ"
			}
		},
		repairtypedata: {
			fields: {
				name: "ชื่อ",
				project: "โครงการ",
				order: "ลำดับ",
				name_contains: "ชื่อ"
			}
		},
		saleagency: {
			fields: {
				name: "ชื่อ",
				project: "โครงการ",
				url: "URL ตัวแทนขาย",
				image: "รูป",
				invoice_to: "ใบแจ้งนี้ถึง (ตัวอย่าง John Doe)",
				invoice_company: "ใบแจ้งนี้ถึงบริษัท (ตัวอย่าง Apple)",
				invoice_address: "ที่อยู่ใบแจ้งนี้",
				price: "ราคา"
			}
		},
		service: {
			fields: {
				name: "ชื่อ",
				name_contains: "ชื่อ",
				type: "ประเภท",
				project: "โครงการ",
				url: "URL บริการ",
				image: "รูป",
				tel: "เบอร์",
				invoice_to: "ใบแจ้งนี้ถึง (ตัวอย่าง John Doe)",
				invoice_company: "ใบแจ้งนี้ถึงบริษัท (ตัวอย่าง Apple)",
				invoice_address: "ที่อยู่ใบแจ้งนี้",
				price: "ราคา"
			}
		},
		areainfo: {
			fields: {
				name: "ชื่อ",
				project: "โครงการ",
				name_contains: "ชื่อ",
				description: "รายละเอียด",
				image: "รูป"
			}
		},
		interesting: {
			fields: {
				name: "ชื่อ",
				name_contains: "ชื่อ",
				type_contains: "ประเภท",
				type: "ประเภท",
				project: "โครงการ",
				image: "รูป",
				brochure: "โบรชัวร์",
				project_info: "ข้อมูลโครงการ",
				promotion: "โปรโมชั่น"
			}
		},
		announce: {
			fields: {
				title: "หัวข้อ",
				title_contains: "หัวข้อ",
				project: "โครงการ",
				expire: "วันหมดอายุ",
				image: "รูป",
				description: "รายละเอียด",
			}
		},
		facilities: {
			fields: {
				name: "ชื่อ",
				name_contains: "ชื่อ",
				time: "เวลาใช้งาน",
				project: "โครงการ",
				type: "ประเภท",
				image: "รูป",
				booking: "สามารถจองได้หรือไม่",
				booking_future_day:
					"จำนวนวันที่สามารถจองล่วงหน้า (สามารถจองล่วงหน้าได้กี่วัน, 0 คือไม่สามารถจองล่วงหน้าได้)",
				booking_user_perday:
					"ผู้ใช้งาน 1 คน สามารถจองสิ่งอำนวยความสะดวกนี้ได้กี่ครั้งต่อวัน (0 คือ จองกี่ครั้งก็ได้)",
				booking_slot_pertime:
					"จำนวนที่ว่างของสิ่งอำนวยความสะดวก (จำนวนที่สามารถจองซํ้ากันได้, 0 คือจำนวนที่ว่างของสิ่งอำนวยความสะดวกไม่จำกัด)"
			}
		},
		facilitybooking: {
			fields: {
				booking_date: "วันที่จอง",
				facility: "สิ่งอำนวยความสะดวก",
				project: "โครงการ",
				user: "ผู้ใช้งาน",
				room: "ห้อง",
				description: "รายละเอียด"
			}
		},
		group: {
			fields: {
				name_contains: "ชื่อ",
				name: "ชื่อ",
				users: "ผู้ใช้งาน"
			}
		},
		hotline: {
			fields: {
				name: "ชื่อ",
				tel: "เบอร์",
				type: "ประเภท",
				project: "โครงการ",
				name_contains: "ชื่อ",
				tel_contains: "เบอร์"
			}
		},
		message: {
			fields: {
				type: "ประเภท",
				project: "โครงการ",
				title: "ชื่อเรื่อง",
				createdAt: "วันที่",
				send_to: "ส่งถึง",
				user: "ผู้ใช้งาน",
				group: "กลุ่ม",
				file: "ใบราคา",
				message: "ข้อความ",
				image: "รูป",
				room: "ห้อง",
				bill_month: "เดือน",
				bill_year: "ปี"
			}
		},
		payment: {
			fields: {
				room: "ห้อง",
				price: "ค่างวด",
				payment_date: "เดือนที่ชำระ",
				project: "โครงการ",
				payment_date_gt: "วันที่เริ่มชำระ",
				payment_date_lt: "วันที่สิ้นสุดการชำระ"
			}
		},
		paymentinvoice: {
			fields: {
				type: "ประเภท",
				ticket_no_contains: "เลขการโอนเงิน",
				project: "โครงการ",
				ticket_no: "เลขการโอนเงิน",
				room: "ห้อง",
				createdAt: "วันที่แจ้ง",
				description: "รายละเอียด",
				image: {
					url: "รูป"
				},
				message: {
					message: "เขียนข้อความ"
				}
			}
		},
		repair: {
			fields: {
				status: "สถานะ",
				project: "โครงการ",
				createdAt: "วันที่แจ้งซ่อม",
				createdAt_gt: "วันที่แจ้งซ่อม",
				ticket_no: "เลขการซ่อม",
				ticket_no_contains: "เลขการซ่อม",
				room_inform: "ห้อง",
				type_data: "พื้นที่การซ่อม",
				type: "การซ่อม",
				user_inform: "เบอร์โทรติดต่อ",
				description: "รายละเอียด",
				message: {
					message: "เขียนข้อความ",
					image: "แนบรูป"
				},
				rating: "คะแนน"
			}
		},
		room: {
			fields: {
				name_contains: "ชื่อห้อง",
				type_contains: "ประเภท",
				name: "ชื่อห้อง",
				type: "ประเภท",
				project: "โครงการ",
				area: "พื้นที่ (Sqm)",
				service_type: "ประเภทบริการ",
				users: "ผู้ใช้งาน",
				images: "รูป",
				optional: {
					owner: {
						MAILBOX: "Mailbox",
						ANNOUNCE: "Announce",
						FACILITY: "Facility",
						REPAIR: "Repair",
						SERVICE: "Service",
						HOTLINE: "Hotline",
					},
					rent: {
						MAILBOX: "Mailbox",
						ANNOUNCE: "Announce",
						FACILITY: "Facility",
						REPAIR: "Repair",
						SERVICE: "Service",
						HOTLINE: "Hotline",
					}
				}
			}
		},
		sos: {
			fields: {
				room: "ห้อง",
				status: "สถานะ",
				project: "โครงการ",
				user: "เบอร์โทรติดต่อ",
				createdAt: "วันที่แจ้ง"
			}
		},
		user: {
			fields: {
				email_contains: "อีเมล์",
				email: "อีเมล์",
				provider: "ช่องทางการลงทะเบียน",
				role: {
					_id: "สิทธิ์"
				},
				firstname: "ชื่อจริง",
				lastname: "นามสกุล",
				password: "รหัสผ่าน",
				mobile: "เบอร์โทร",
				project: "โครงการ",
				permission: "การอนุญาต"
			}
		},
		bill: {
			fields: {
				project: "โครงการ",
				date: "บิลประจำเดือน/ปี",
				room: "ห้อง",
				water_bill: "ค่านํ้าประปา (บาท)",
				water_bill_image: "รูปบิลค่านํ้าประปา",
				electric_bill: "ค่าไฟฟ้า (บาท)",
				electric_bill_image: "รูปบิลค่าไฟฟ้า",
				maintenance_fee: "ค่าส่วนกลาง (บาท)",
				installment: "ค่าผ่อนชำระ (บาท)"
			}
		},
		billtype: {
			fields: {
				project: "โครงการ",
				date: "บิลประจำเดือน/ปี",
				room: "ห้อง",
			}
		},
		line: {
			title: "Line",
			fields: {
				name: "ชื่อ",
				key: "คีย์",
				name_contains: "ชื่อ",
				key_contains: "คีย์"
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/locales/th.js